
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { InputNumerico } from "../inputs/InputNumerico";
import globalMU from "globalMU";
const estiloTabela = require('../../estilos/tabelas.module.scss').default



export type DespesaOrcamento = { // 440122
  Id: number,
  OidDespesa: number,
  NomeDespesa: string,
  OidFornecedor: number,
  NomeFornecedor: string,
  Valor: number,
  Fornecedores: FornecedoreDespesaOrcamento[]
}

export type FornecedoreDespesaOrcamento = { // 440122
  Codigo: number,
  Nome: string,
  CpfCnpj: string,
}


export type DespesasOrcamentoProps = {
  despesas: DespesaOrcamento[],
  somenteLeitura: boolean,
  onAtualizarDespesa?: (oidDespesa: number, oidFornecedor: number, valor: number) => void,
}

export const DespesasOrcamento = (props: DespesasOrcamentoProps) => {

  const tabelaDespesas = 
  <div className={estiloTabela.containerRolavel}>
    <table
        className={clsx(estiloTabela.tabela, "_w-full")}
        id="DespesasOrcamento_TabelaDespesas"
    >
        <thead>
            <tr>
                <th  className={estiloTabela.cabecalhoTexto}>Tipo de Serviço</th>
                <th  className={estiloTabela.cabecalhoTexto}>Prestador de Serviço</th>
                <th  className={estiloTabela.cabecalhoNumerico}>Valor</th>
            </tr>
        </thead>
        <tbody>
          {props?.despesas?.map(d =>
                <tr 
                  key={`DespesasOrcamento-key-${d.OidDespesa}`}
                  id={`DespesasOrcamento-id-${d.OidDespesa}`}
                  className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}
                >
                  <td>{d.NomeDespesa}</td>
                  <td>
                    <select 
                        value={(d.OidFornecedor) ?? ""} 
                          disabled={props.somenteLeitura}
                          style={{width:  '100%' }}
                          onChange={(e) => {
                            props.onAtualizarDespesa(d.OidDespesa, parseInt(e.target.value), d.Valor)}}
                          >
                          <option value={0}>Nenhum</option>
                          {
                              d?.Fornecedores?.map((item) => (
                                  <option 
                                    key={item?.Codigo?.toString()}
                                    value={item?.Codigo?.toString()}
                                  >
                                    {`${item.Nome} [${item.CpfCnpj}]`}
                                  </option>
                              ))
                          }
                      </select>


                  </td>
                  <td className={estiloTabela.dadoNumerico}>
                      <InputNumerico
                        valor={d.Valor}
                        onValorModificado={(valorModificado) => { 
                          if (valorModificado < 0)
                          {
                            globalMU.showErrorMessage("O valor não pode ser negativo.")
                          }
                          else
                          {
                            props.onAtualizarDespesa(d.OidDespesa, d.OidFornecedor, valorModificado)}}
                          }
                        numeroCasasDecimais={2}
                        permitirValorNegativo={false}
                        disabled={props.somenteLeitura}
                        selecionaValorOnFocus={true}
                        style={{width: '100%' }}
                        id={`DespesasOrcamento-id-${d.Id}`}
                    />
                  </td>
                </tr>
              )}

        </tbody>
        <tfoot>
            <tr>
                <td colSpan={2} className={estiloTabela.cabecalhoNumerico}>Total de Despesas&nbsp;</td>
                <td className={estiloTabela.cabecalhoNumerico}>
                    {globalMU.formatarValorNumerico(props.despesas.reduce((acc, d) => acc + d.Valor, 0), 2)}&nbsp;&nbsp;&nbsp;
                </td>
            </tr>
            </tfoot>
    </table>
  </div>
  return (
    <>
    {props.despesas != null && props.despesas.length > 0 &&
        tabelaDespesas
    }
    <section style={{ marginBottom: "100px" }} />
    </>
  );
};
